import React from 'react';
import IframeResizer from '@iframe-resizer/react';
export const IFrame = ({
  src,
  style = {},
}: {
  src: string;
  style?: React.CSSProperties;
}) => {
  return (
    <IframeResizer
      license={'GPLv3'}
      src={src}
      style={{ width: '100%', height: '100vh', ...style }}
      frameBorder="0"
    />
  );
};
